var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem18C(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 750 289"
    },
    viewBox: "0 0 750 289",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M750 0H0v289.4h750V0z",
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211 155.7c-.2-1.5-1-2.3-2.5-2.5-1.5.2-2.4 1-2.5 2.5.1 1.6.9 2.5 2.5 2.6 1.6-.1 2.4-1 2.5-2.6zm3.1-55.1c-.1-1.3-.6-2.5-1.6-3.5-.9-.9-2.1-1.4-3.6-1.5-1.6 0-2.9.5-4 1.5-1 1-1.5 2.3-1.5 3.8 0 1.6.4 3 1.3 4 .1 0 .1 0 .1.1-.3.5-.4 1-.4 1.6.1 1.2.4 2.1 1.2 2.8.8.7 1.8 1.1 2.8 1.2l1.2-.3c.7-.2 1.3-.5 1.8-1.2s.9-1.4 1-2.5c-.1-.9-.3-1.6-.8-2.1-.7-.9-1.4-1.4-2-1.5-.7-.2-1.1-.2-1.2-.2h-.2c-.3-.1-.5-.2-.7-.3-.3-.3-.5-.8-.5-1.5 0-.5.2-.9.5-1.2.3-.2.7-.3 1.3-.3.4 0 .8.2 1.2.5.3.2.4.4.3.7v.8l-.2.2 2.6 2.6c.5-.4.8-1 1-1.6s.4-1.4.4-2.1m-5.6 6.1h-.3l.1-.2.2.1v.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213 146.8c-.1-1.2-.4-2.1-1.2-2.8-.7-.7-1.6-1.1-2.8-1.2-.4.1-.8.1-1.2.2-.7.3-1.3.7-1.8 1.3-.5.5-.8 1.4-.8 2.5-.1.9.2 1.6.7 2.1.7.8 1.4 1.3 2.1 1.5.5.1.9.2 1.2.2.3 0 .5.1.8.3.2.2.3.6.3 1.3 0 .6-.2 1-.5 1.2-.2.3-.6.5-1.2.5s-.9-.2-1.2-.5c-.3-.3-.5-.5-.5-.8-.1-.4 0-.7.2-.8l-2.6-2.6c-.5.4-.8.9-1 1.6-.2.6-.2 1.2-.2 1.8 0 1.5.5 2.6 1.5 3.5 1 1 2.3 1.6 3.8 1.6 1.5-.1 2.7-.6 3.8-1.5 1-1.1 1.6-2.4 1.6-4 0-1.5-.5-2.8-1.5-3.8l-.1-.1c.4-.4.6-.9.6-1.5m-4.2-.2h.3l.1.1-.1.2-.3-.1v-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M238.4 161.7v-5.8H33.3v5.8h205.1z",
    style: {
      fill: "#7f7f7f"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239 162.1v-6.9H32.8v6.9H239m-1.2-5.6v4.4H34.1v-4.4h203.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m63.4 193.9-12-32.3-11.9 32.3h23.9zm145-88.1c-12.6 1.2-19.5 8.1-20.8 20.8 1.2 12.6 8.1 19.5 20.8 20.8 12.7-1.2 19.6-8.1 20.8-20.8-1.2-12.7-8.1-19.6-20.8-20.8m19.4 20.8c-.1 5.5-2 10.2-5.6 13.8-3.7 3.6-8.3 5.5-13.8 5.6-5.5-.1-10-2-13.7-5.6-3.7-3.7-5.7-8.3-5.8-13.8.1-5.5 2-10.1 5.8-13.8 3.6-3.6 8.2-5.4 13.7-5.6 5.5.2 10.1 2 13.8 5.6 3.7 3.7 5.5 8.3 5.6 13.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M226.5 126.7c-1-11.1-7.1-17.1-18.1-18.1-11 1-17 7-18.1 18.1 1.1 11.1 7.1 17.1 18.1 18.1 11-1 17-7 18.1-18.1z",
    style: {
      fill: "#fff"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M189.6 126.7c1.1 11.4 7.3 17.6 18.6 18.6 11.5-1 17.7-7.2 18.8-18.6-1-11.4-7.3-17.7-18.8-18.8-11.2 1.1-17.5 7.4-18.6 18.8m6.3-12.4c3.3-3.3 7.4-5 12.4-5.1 5.1.1 9.2 1.8 12.4 5.1 3.3 3.3 5 7.4 5.1 12.4-.1 4.9-1.8 9.1-5.1 12.4-3.2 3.2-7.3 4.9-12.4 5.1-4.9-.2-9.1-1.9-12.4-5.1-3.2-3.3-4.9-7.4-5.1-12.4.2-5 1.9-9.1 5.1-12.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211 126.6c-.2-1.6-1-2.5-2.6-2.6-1.6.2-2.5 1-2.6 2.6.1 1.6 1 2.5 2.6 2.6 1.5-.1 2.4-1 2.6-2.6zm-2-13.1v-4.9h-1.3v4.9h1.3zm12.5.8-.8-.8-3.5 3.5.8.8 3.5-3.5zm5 13.1v-1.3h-4.9v1.3h4.9zm-5 11.6-3.5-3.5-.8.8 3.5 3.5.8-.8zm-12.5 5.6v-4.8h-1.3v4.8h1.3zm-9.5-8.3-.8-.8-3.5 3.5.8.8 3.5-3.5zm-4.4-8.9v-1.3h-4.8v1.3h4.8zm4.4-10.4-3.5-3.5-.8.8 3.5 3.5.8-.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.3 176v-20.1h-6.4V176h6.4z",
    style: {
      fill: "#fff"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M138.9 155.2h-7.7v21.4h7.7v-21.4m-6.5 1.3h5.4v18.9h-5.4v-18.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M158.2 184.3V164h-46.3v20.3h46.3z",
    style: {
      fill: "#fff"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M158.9 185v-21.6h-47.4V185h47.4m-1.3-20.3v18.9h-45v-18.9h45zm81-65.5v-3.8H33.3v3.8h205.3zm0 94.9v-1.3H33.3v1.3h205.3z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(117.574 179.975)",
    style: {
      fontSize: "14.826px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "\n    50kg\n  "), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M208.6 100.7c1.5-.2 2.3-1 2.5-2.5 0-.5-.1-.8-.4-.7-.5.2-1.2.4-2.1.6-1-.2-1.7-.4-2.1-.6-.2-.1-.3.2-.3.7 0 1.4.8 2.2 2.4 2.5zm241.5 55c-.1-1.5-.9-2.3-2.5-2.5-1.5.2-2.3 1-2.5 2.5.2 1.6 1 2.5 2.5 2.6 1.7-.1 2.5-1 2.5-2.6zm3-55.1c-.1-1.3-.5-2.5-1.5-3.5-1-.9-2.3-1.4-3.8-1.5-1.5 0-2.7.5-3.8 1.5-1 1-1.6 2.3-1.6 3.8 0 1.6.5 3 1.5 4-.2.5-.4 1-.5 1.6.1 1.2.5 2.1 1.3 2.8.7.7 1.6 1.1 2.8 1.2.3-.1.7-.2 1.2-.3.5-.2 1.1-.5 1.6-1.2.7-.6 1-1.4 1-2.5-.1-.9-.3-1.6-.7-2.1-.7-.9-1.4-1.4-2.1-1.5-.6-.2-1-.2-1.2-.2h-.2c-.2-.1-.4-.2-.7-.3-.2-.3-.4-.8-.5-1.5 0-.5.2-.9.5-1.2.3-.2.7-.3 1.3-.3.5 0 .9.2 1.2.5.3.2.5.4.5.7-.1.5-.1.8-.2.8v.2l2.6 2.6c.3-.4.7-1 1-1.6.3-.7.3-1.3.3-2m-5.6 6.1h-.3l.2-.2.2.1v.1z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M452.1 146.8c0-1.2-.4-2.1-1.3-2.8-.7-.7-1.6-1.1-2.8-1.2-.3.1-.7.1-1.2.2-.5.3-1.1.7-1.8 1.3-.5.5-.8 1.4-.8 2.5.1.9.3 1.6.7 2.1.7.8 1.4 1.3 2.1 1.5.7.1 1 .2 1.2.2h.2c.2 0 .4.1.7.3.3.2.4.6.5 1.3-.1.6-.2 1-.5 1.2-.4.3-.8.5-1.3.5-.4 0-.8-.2-1.2-.5-.3-.3-.5-.5-.5-.8.1-.4.1-.6.2-.7v-.2l-2.6-2.6c-.3.4-.7.9-1 1.6-.2.6-.2 1.2-.2 1.8.1 1.5.6 2.6 1.5 3.5 1 1 2.3 1.6 3.8 1.6 1.5-.1 2.8-.6 3.8-1.5 1-1.1 1.6-2.4 1.6-4 0-1.5-.5-2.8-1.5-3.8.1-.4.3-.9.4-1.5m-4.1-.2h.3v.2l-.1.1-.2-.1v-.2z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M477.5 161.7v-5.8h-205v5.8h205z",
    style: {
      fill: "#7f7f7f"
    }
  }), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M478.1 162.1v-6.9H271.9v6.9h206.2m-1.3-5.6v4.4H273.1v-4.4h203.7z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m302.4 193.9-12-32.3-11.9 32.3h23.9zm145.1-88.1c-12.7 1.2-19.6 8.1-20.8 20.8 1.2 12.6 8.1 19.5 20.8 20.8 12.6-1.2 19.4-8.1 20.6-20.8-1.2-12.7-8.1-19.6-20.6-20.8m19.4 20.8c-.1 5.5-2 10.2-5.8 13.8-3.7 3.6-8.2 5.5-13.7 5.6-5.6-.1-10.2-2-13.8-5.6-3.7-3.7-5.7-8.3-5.8-13.8.1-5.5 2-10.1 5.8-13.8 3.6-3.6 8.2-5.4 13.8-5.6 5.4.2 10 2 13.7 5.6 3.8 3.7 5.7 8.3 5.8 13.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.6 126.7c-1-11.1-7-17.1-18-18.1-11.1 1-17.1 7-18.1 18.1 1 11.1 7 17.1 18.1 18.1 10.9-1 16.9-7 18-18.1z",
    style: {
      fill: "#fff"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M428.7 126.7c1 11.4 7.3 17.6 18.8 18.6 11.3-1 17.5-7.2 18.6-18.6-1.1-11.4-7.3-17.7-18.6-18.8-11.5 1.1-17.8 7.4-18.8 18.8m6.4-12.4c3.2-3.3 7.4-5 12.4-5.1 4.9.1 9 1.8 12.2 5.1 3.4 3.3 5.2 7.4 5.3 12.4-.1 4.9-1.9 9.1-5.3 12.4-3.2 3.2-7.3 4.9-12.2 5.1-5-.2-9.1-1.9-12.4-5.1-3.4-3.3-5.2-7.4-5.3-12.4.2-5 1.9-9.1 5.3-12.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M450.2 126.6c-.2-1.6-1.1-2.5-2.6-2.6-1.7.2-2.6 1-2.8 2.6.2 1.6 1.1 2.5 2.8 2.6 1.5-.1 2.4-1 2.6-2.6zm-2.2-13.1v-4.9h-1.2v4.9h1.2zm12.7.8-1-.8-3.5 3.5 1 .8 3.5-3.5zm4.8 13.1v-1.3h-4.9v1.3h4.9zm-4.8 11.6-3.5-3.5-1 .8 3.5 3.5 1-.8zm-12.7 5.6v-4.8h-1.2v4.8h1.2zm-9.4-8.3-1-.8-3.5 3.5 1 .8 3.5-3.5zm-4.2-8.9v-1.3h-4.9v1.3h4.9zm4.2-10.4-3.5-3.5-1 .8 3.5 3.5 1-.8zM477.9 99.2v-3.8H272.5v3.8zm0 94.9v-1.3H272.5v1.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M447.7 100.7c1.6-.2 2.4-1 2.5-2.5 0-.5-.1-.8-.3-.7-.4.2-1.2.4-2.1.6-.9-.2-1.6-.4-2.1-.6-.3-.1-.4.2-.4.7.1 1.4.9 2.2 2.4 2.5zm241.6 55c-.1-1.5-1-2.3-2.6-2.5-1.5.2-2.3 1-2.5 2.5.2 1.6 1 2.5 2.5 2.6 1.6-.1 2.5-1 2.6-2.6zm2.9-55.1c0-1.3-.5-2.5-1.5-3.5-1-.9-2.3-1.4-3.8-1.5-1.5 0-2.8.5-3.8 1.5s-1.6 2.3-1.6 3.8c0 1.6.5 3 1.5 4l.1.1c-.3.4-.4 1-.4 1.6.1 1.2.4 2.1 1.2 2.8.7.7 1.6 1.1 2.8 1.2l1.2-.3c.6-.2 1.2-.5 1.8-1.2.5-.6.8-1.4.8-2.5 0-.9-.2-1.6-.7-2.1-.7-.9-1.4-1.4-2.1-1.5-.5-.2-.9-.2-1.2-.2-.4-.1-.7-.2-.8-.3-.2-.3-.3-.8-.3-1.5 0-.5.1-.9.3-1.2.3-.2.8-.3 1.3-.3.4 0 .8.2 1.2.5.3.2.5.4.5.7 0 .5-.1.8-.2.8v.2l2.6 2.6c.5-.4.8-1 1-1.6s.2-1.4.1-2.1m-5.4 5.9v.2h-.3l-.2-.2.1-.2.4.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M691.2 146.8c-.1-1.2-.5-2.1-1.3-2.8-.7-.7-1.6-1.1-2.6-1.2-.4.1-.9.1-1.3.2-.5.3-1.1.7-1.6 1.3-.7.5-1 1.4-1 2.5 0 .9.3 1.6.8 2.1.8.8 1.4 1.3 2 1.5.7.1 1.1.2 1.2.2h.2c.3 0 .5.1.7.3.2.2.4.6.5 1.3 0 .6-.2 1-.5 1.2-.3.3-.7.5-1.3.5-.5 0-.9-.2-1.2-.5-.3-.3-.4-.5-.3-.8v-.8h.2l-2.6-2.6c-.5.4-.8.9-1 1.6-.2.6-.3 1.2-.3 1.8.1 1.5.6 2.6 1.6 3.5.9 1 2.1 1.6 3.6 1.6 1.5-.1 2.9-.6 4-1.5 1-1.1 1.5-2.4 1.5-4-.1-1.5-.5-2.8-1.3-3.8l-.1-.1c0-.5.1-1 .1-1.5m-4.1-.2h.3l-.2.2-.2-.1v-.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M716.5 161.7v-5.8H511.6v5.8h204.9z",
    style: {
      fill: "#7f7f7f"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M717.2 162.1v-6.9H511v6.9h206.2m-1.1-5.6v4.4H512.2v-4.4h203.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m587.117 193.564-11.9-32.3-12 32.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M704.6 126.7c-1.1-11.1-7.1-17.1-18.1-18.1-11 1-17.1 7-18.1 18.1 1 11.1 7.1 17.1 18.1 18.1 11-1 17-7 18.1-18.1z",
    style: {
      fill: "#fff"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M667.8 126.7c1.1 11.4 7.4 17.6 18.8 18.6 11.3-1 17.5-7.2 18.6-18.6-1.1-11.4-7.3-17.7-18.6-18.8-11.5 1.1-17.8 7.4-18.8 18.8m6.4-12.4c3.2-3.3 7.4-5 12.4-5.1 4.9.1 9.1 1.8 12.4 5.1 3.3 3.3 5 7.4 5.1 12.4-.1 4.9-1.8 9.1-5.1 12.4-3.3 3.2-7.4 4.9-12.4 5.1-5-.2-9.1-1.9-12.4-5.1-3.2-3.3-4.9-7.4-5.1-12.4.1-5 1.8-9.1 5.1-12.4z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M689.2 126.6c-.2-1.6-1-2.5-2.6-2.6-1.6.2-2.5 1-2.6 2.6.1 1.6 1 2.5 2.6 2.6 1.6-.1 2.5-1 2.6-2.6zm-2-13.1v-4.9h-1.3v4.9h1.3zm12.5.8-.8-.8-3.5 3.5.8.8 3.5-3.5zm4.7 13.1v-1.3h-4.8v1.3h4.8zm-4.7 11.6-3.5-3.5-.8.8 3.5 3.5.8-.8zm-12.5 5.6v-4.8h-1.3v4.8h1.3zm-9.6-8.3-.8-.8-3.5 3.5.8.8 3.5-3.5zm-4.3-8.9v-1.3h-4.9v1.3h4.9zm4.3-10.4-3.5-3.5-.8.8 3.5 3.5.8-.8zm39.3-17.8v-3.8H511.6v3.8h205.3zm0 94.9v-1.3H511.6v1.3h205.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M638.7 176v-20.1h-6.4V176z",
    style: {
      fill: "#fff"
    }
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M639.3 155.2h-7.7v21.4h7.7v-21.4m-6.4 1.3h5.3v18.9h-5.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M658.6 184.3V164h-46.3v20.3z",
    style: {
      fill: "#fff"
    }
  }), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M659.3 185v-21.6h-47.4V185h47.4m-1.3-20.3v18.9h-45v-18.9z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 618.074,
    y: 179.975,
    style: {
      fontSize: "14.826px",
      fontFamily: "'Arial-BoldMT'"
    }
  }, "50kg  "), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M686.7 100.7c1.6-.2 2.5-1 2.6-2.5 0-.5-.1-.8-.4-.7-.5.2-1.2.4-2.2.6-.9-.2-1.6-.4-2.1-.6-.3-.1-.4.2-.4.7.2 1.4 1 2.2 2.5 2.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M541.3 117.4c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 528.817 130.968)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    3\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M298.2 117.4c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 285.667 130.968)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    2\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M61.3 117.4c-2.4-2.4-5.2-3.6-8.6-3.6-3.4 0-6.3 1.2-8.7 3.6-2.4 2.4-3.6 5.3-3.6 8.7 0 3.4 1.2 6.3 3.6 8.7 2.4 2.4 5.3 3.6 8.7 3.6 3.4 0 6.2-1.2 8.6-3.6 2.4-2.4 3.6-5.3 3.6-8.7 0-3.4-1.2-6.3-3.6-8.7z",
    style: {
      fill: "#369",
      fillOpacity: 0.502
    }
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(.9981 0 0 1 48.817 130.968)",
    style: {
      fontSize: "11.4815px",
      fontFamily: "'ArialMT'",
      fill: "#fff"
    }
  }, "\n    1\n  "), /*#__PURE__*/React.createElement("path", {
    d: "M334.237 175.793v-20.1h-6.4v20.1z",
    style: {
      fill: "#fff"
    }
  }), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M334.837 154.993h-7.7v21.4h7.7v-21.4m-6.4 1.3h5.3v18.9h-5.3z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 184.093v-20.3h-46.3v20.3z",
    style: {
      fill: "#fff"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M354.837 184.793v-21.6h-47.4v21.6h47.4m-1.3-20.3v18.9h-45v-18.9z"
  })), /*#__PURE__*/React.createElement("text", {
    style: {
      fontSize: "14.826px",
      fontFamily: "Arial-BoldMT"
    },
    x: 313.611,
    y: 179.768
  }, "75kg"), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M686.7 105.8c-12.7 1.2-19.6 8.1-20.8 20.8 1.2 12.6 8.1 19.5 20.8 20.8 12.5-1.2 19.4-8.1 20.6-20.8-1.2-12.7-8.1-19.6-20.6-20.8m19.4 20.8c-.1 5.5-2 10.2-5.8 13.8-3.7 3.6-8.2 5.5-13.7 5.6-5.5-.1-10.2-2-13.8-5.6-3.6-3.7-5.5-8.3-5.6-13.8.1-5.5 2-10.1 5.6-13.8 3.7-3.6 8.3-5.4 13.8-5.6 5.4.2 10 2 13.7 5.6 3.8 3.7 5.7 8.3 5.8 13.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem18C);
export default __webpack_public_path__ + "static/media/item18c.df00f3a043a38f5f265ec442ff222fb5.svg";
export { ForwardRef as ReactComponent };